import { useTranslation } from 'react-i18next';
import DividerWithText from '../../../../../components/DividerWithText';
import PhotoPickerSummary from '../../../../../components/PhotoPicker/PhotoPickerSummary';
import SummaryContainer from '../../Components/SummaryContainer';
import SummaryFieldsUser from '../../Components/SummaryFieldsUser';
import RowResumeText from '../../../../../components/RowResumeText';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param user
 * @param photoPicker
 */
const SummaryEmployeeContractor = ({ user, photoPicker, extraDataEnabled, headersList, extraData }) => {
    const { t } = useTranslation();

    return (
        <div className='px-2'>
            <DividerWithText title={t('take_photography')} />
            <PhotoPickerSummary photoPicker={photoPicker} classWith={'content-center-w-400px'} />
            <DividerWithText title={t('employee_details')} />
            <div className='d-flex justify-content-center'>
                <SummaryContainer>
                    <div className='row'>
                        <SummaryFieldsUser user={user} />
                    </div>
                </SummaryContainer>
            </div>
            {extraDataEnabled && (
                <>
                    <DividerWithText title={t('other_details')} />
                    <div className='d-flex justify-content-center'>
                        <SummaryContainer>
                            <div className='row'>
                                <div className='grid-container-resume-data mb-2'>
                                    {Array.from({ length: 15 }, (_, index) => (
                                        <RowResumeText
                                            key={index}
                                            title={headersList[`header${index + 1}`] || `header_${index + 1}`}
                                            value={extraData[`field${index + 1}`]}
                                        />
                                    ))}
                                </div>
                            </div>
                        </SummaryContainer>
                    </div>
                </>
            )}
        </div>
    );
};

export default SummaryEmployeeContractor;
